<template>
    <div>
        <h1>Ester</h1>
        <p>
            Ester sind Verbindungen, die durch die Reaktion von einer Säure und
            einem <router-link to="alkohole">Alkohol</router-link> entstehen.
            Dabei entsteht auch Wasser, die Veresterung ist also eine
            Kondentation.<br />
            Carbonsäureester entstehen aus einer
            <router-link to="carbon">Carbonsäure</router-link> und einem
            <router-link to="alkohole">Alkohol</router-link>.
        </p>
        <img
            src="@/assets/img/stoffe/ester/allgemeine-struktur.png"
            width="256px"
            height="auto"
            alt="Allgemeine Struktur der Ester"
            title="Allgemeine Struktur der Ester"
        />
        <hr class="chapter-split" />
        <chapter-heading title="Nomenklatur"></chapter-heading>
        <p>
            1-Butanol + Propansäure ⇌ Propansäurebutylester<br />
            1-Butanol + Ethansäure ⇌ Ethansäurebutylester<br />
            Ethanol + Benzoesäure ⇌ Benzoesäureethylester<br />
            <b>Allgemein:</b> Der Ester erhält den Namen der Säure +
            Funktionelle Gruppe des Alkohols + "ester".
        </p>
        <img
            src="@/assets/img/stoffe/ester/teile.png"
            alt="Ester bestehen aus zwei Teilen"
            title="Ester bestehen aus zwei Teilen"
        />
        <hr class="chapter-split" />
        <chapter-heading title="Herstellung"></chapter-heading>
        <p>
            Säure + <router-link to="alkohol">Alkohol</router-link> ⇌ Ester +
            Wasser
            <small>Reaktionstyp: Kondensation</small>
        </p>
        <p>
            Die Rückreaktion bei der Ester zu Alkohol und einer Säure wird ist
            eine Hydrolyse.
        </p>
        <hr class="chapter-split" />
        <chapter-heading title="Verwendung"></chapter-heading>
        <ul>
            <li>Fette und Öle (Ester von Glycerin und Fettsäuren)</li>
            <li>
                Monoglyceride (Ester aus Glycerin und einer Fettsäure) als
                Emulgatoren einetzbar
            </li>
            <li>Polyester, als Kunststoff</li>
        </ul>
        <hr class="chapter-split" />
        <chapter-heading
            title="Beispiel einer Strukturformel"
        ></chapter-heading>
        <img
            src="@/assets/img/stoffe/ester/propansaeurebutylester.png"
            alt="Beispielhafte Strukturformel: Propansäurebutylester"
            title="Beispielhafte Strukturformel: Propansäurebutylester"
        />
        <hr class="chapter-split" />
        <chapter-heading title="Zusammenfassung"></chapter-heading>
        <table>
            <tr>
                <th>Beschreibung</th>
                <td>
                    <ul>
                        <li>bestehen aus einem Alkohol und einer Säure</li>
                        <li>
                            enstehen durch die Abspaltung von Wasser =>
                            Kondensation
                        </li>
                    </ul>
                </td>
            </tr>
        </table>
    </div>
</template>
<script>
import ChapterHeading from '../../components/chapterHeading';
export default {
    components: { ChapterHeading },
};
</script>
